<template>
	<div
		class="avatar-dropdown position-relative"
		v-focus-outside="closeDropdown"
		v-click-outside="closeDropdown"
	>
		<BButton
			link
			@clickOrEnter="handleSwitchDropdown"
			class="cursor-pointer align-items-center display-flex avatar-dropdown-action"
		>
			<BAvatar :avatarUrl="avatarUrl" :name="name" tiny class="margin-right-tiny" />

			<BNewBIconExpandMore class="dropdown-icon" v-if="!isOpen" />
			<BNewBIconExpandLess class="dropdown-icon" v-else />
		</BButton>

		<div
			v-if="isOpen"
			class="
				avatar-dropdown-content
				position-absolute
				bg-white-base
				border border-white-darker-4 border-radius
				elevation-2dp
			"
		>
			<slot name="dropdownContent"> </slot>
		</div>
	</div>
</template>

<script>
import BAvatar from './Avatar';
import BButton from './Button';
import { BNewBIconExpandMore, BNewBIconExpandLess } from './new_icons';

export default {
	name: 'b-avatar-dropdown',
	components: {
		BAvatar,
		BNewBIconExpandMore,
		BNewBIconExpandLess,
		BButton,
	},
	props: {
		/**
		 * Url da imagem que será usada como `background` do avatar
		 */
		avatarUrl: {
			type: String,
		},
		/**
		 * Nome do qual são extraídas as iniciais que serão exibidas no avatar, caso a prop `avatarUrl` não seja passada
		 */
		name: {
			type: String,
			default: '',
		},
	},
	directives: {
		'click-outside': {
			bind: function (el, binding, vnode) {
				el.clickOutsideEvent = function (event) {
					if (!(el == event.target || el.contains(event.target))) {
						vnode.context[binding.expression](event);
					}
				};
				document.body.addEventListener('click', el.clickOutsideEvent);
			},
			unbind: function (el) {
				document.body.removeEventListener('click', el.clickOutsideEvent);
			},
		},
		'focus-outside': {
			bind: function (el, binding, vnode) {
				el.focusOutsideEvent = function (event) {
					if (!(el == event.target || el.contains(event.target))) {
						vnode.context[binding.expression](event);
					}
				};
				document.addEventListener('focusin', el.focusOutsideEvent);
			},
			unbind: function (el) {
				document.removeEventListener('focusin', el.focusOutsideEvent);
			},
		},
	},
	data() {
		return {
			isOpen: false,
		};
	},
	methods: {
		handleSwitchDropdown() {
			this.isOpen = !this.isOpen;
		},
		closeDropdown() {
			if (this.isOpen != false) {
				this.isOpen = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@bossabox-code/design-system/css/_variables.scss';
.avatar-dropdown {
	&-action {
		width: fit-content;

		/deep/ {
			display: flex;
		}
	}

	&-content {
		top: 5.3rem;
		right: 0;
		z-index: 10;
		min-width: 10rem;
		min-height: 1rem;
	}

	/deep/ .dropdown-icon {
		pointer-events: none;

		path {
			fill: map-get($colors, 'ink-lighter-1');
		}
	}
}
</style>

<docs>
    ```js
    <b-avatar-dropdown 
		name="Nome Usuário"
		avatarUrl="https://via.placeholder.com/150"
	>
		<template v-slot:dropdownContent>
			<ul>
				<li>Perfil</li>
				<li>Configurações</li>
				<li>Sair</li>
			</ul>
		</template>	
	</b-avatar-dropdown>
    ```
</docs>
